export const registerPage = () =>
  import("./RegisterPage").then((m) => ({ Component: m.RegisterPage }));
